import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnInit} from '@angular/core';
import {PLAN_TYPES} from '../../../user-account/user.model';
import {BUTTON_STYLES, BUTTON_TYPES} from 'kaizen-design-system';
import {DBC_PLANS_BREIF_DATA} from '../dbc-plan-data';
import {AuthService} from '../../../global-services/auth.service';
import {DBC_PRICE_PAGE_TYPE} from '../dbc-pricing-page.component';
import {Subject} from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-dbc-plan-detail-card',
    templateUrl: './plan-detail-card.component.html',
    styleUrls: ['./plan-detail-card.component.scss']
})

export class PlanDetailCardComponent implements OnChanges, OnInit {
    @Input() plan: PLAN_TYPES;
    @Input() selectedPlan: PLAN_TYPES;
    @Input() title: string;
    @Input() pageType: DBC_PRICE_PAGE_TYPE = DBC_PRICE_PAGE_TYPE.UPGRADE;

    @Output() onBuyPlanClickChange: EventEmitter<PLAN_TYPES> = new EventEmitter<PLAN_TYPES>();
    @Output() addMoreUserSeats: EventEmitter<PLAN_TYPES> = new EventEmitter<PLAN_TYPES>();
    // Variables for user-seat-input component
    @Input() showUserSeatInputBox: boolean = false;
    @Input() currentUserSeats: number = 1;
    @Input() minUsersToShow: number = 1;
    @Input() maxUsersToShow: number = 1600;
    @Input() currentTotalUserSeats: number = 1;
    @Output() userSeatsChange: EventEmitter<number> = new EventEmitter<number>();
    @Input() priceToShow: number;
    @Input() dbc_default_user_seat_change_experiment: boolean = false;
    DBC_PLANS_BREIF_DATA = DBC_PLANS_BREIF_DATA;
    isSelectedPlan: boolean = false;
    BUTTON_TYPES = BUTTON_TYPES;
    protected readonly BUTTON_STYLES = BUTTON_STYLES;
    protected readonly PLAN_TYPES = PLAN_TYPES;

    currentPlan: PLAN_TYPES;
    userSeatToBuyCount: any = 1
    userSeatInitialisedForExperiment: boolean = false;

    private userSeatCountChange: Subject<number> = new Subject<number>();
    private ngUnsubscribe: Subject<any> = new Subject<any>();

    constructor(private authService: AuthService) {
        this.currentPlan = this.authService.getUser().dbcCustomerPlan;
    }

    ngOnChanges(changes: SimpleChanges) {
        // Get the selector to Teams
        if (this.plan === PLAN_TYPES.DBCNTeam){
            this.isSelectedPlan = true;
        }
        // If the user seat is not initialized for experiment, make it 3
        if (!this.userSeatInitialisedForExperiment){
            if (this.dbc_default_user_seat_change_experiment && this.priceToShow){
                this.userSeatInitialisedForExperiment = true;
                this.userSeatToBuyCount = 3;
                this.userSeatsChange.emit(3);
            }
        }
    }

    ngOnInit() {
        // On any change make sure the validity of the user seat count
        this.userSeatCountChange.pipe(takeUntil(this.ngUnsubscribe), debounceTime(400)).subscribe((res) => {
            // To avoid appending 1 before the number user types after clearing the input field
            if (String(res) === ''){
                // set the seat count to min for the parent component, to counter the case when the input box is left blank
                this.userSeatsChange.emit(this.minUsersToShow);
                return;
            }
            this.userSeatToBuyCount = res;
            if (this.userSeatToBuyCount < this.minUsersToShow) {
                this.userSeatToBuyCount = this.minUsersToShow;
            } else if (this.userSeatToBuyCount > this.maxUsersToShow){
                this.userSeatToBuyCount = this.maxUsersToShow;
            }
            // Parent component can listen to the changes made in user seat
            this.userSeatsChange.emit(this.userSeatToBuyCount);
        });
        // Intially making the user seats equal to the user seat passed into component

        this.userSeatToBuyCount = this.currentTotalUserSeats;
    }

    changePlan(event) {
        this.onBuyPlanClickChange.emit(event);
    }

    // Called when input value changes
    handleUserSeatChange(event) {
        this.userSeatCountChange.next(event);
    }

    onInputBlur(){
        this.userSeatCountChange.next(this.userSeatToBuyCount);
    }

    onAddMoreUserSeats(event: PLAN_TYPES) {
        this.addMoreUserSeats.emit(event)
    }

}
